module.exports = "img/flags/PL.f6e5ef1.png";